import { useEffect, useState, useContext } from "react";
import "./HomeClient.css";
import { LanguageContext } from "../../context/LanguageContext";

const useCountUp = (end, duration) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const incrementTime = 20;
    const steps = Math.ceil(duration / incrementTime);
    const stepValue = end / steps;

    const counter = setInterval(() => {
      start += stepValue;
      if (start >= end) {
        clearInterval(counter);
        setCount(end);
      } else {
        setCount(Math.ceil(start));
      }
    }, incrementTime);

    return () => clearInterval(counter);
  }, [end, duration]);

  return count;
};

const clients = [
  { id: 1, src: "/assets/clients/bjp.png", alt: "BJP"},
  { id: 2, src: "/assets/clients/reliance.png", alt: "Reliance" },
  { id: 3, src: "/assets/clients/raymond.png", alt: "Raymond" },
  { id: 4, src: "/assets/clients/iskcon.png", alt: "Iskcon" },
  { id: 5, src: "/assets/clients/tata.png", alt: "Tata" },
  { id: 6, src: "/assets/clients/mahindra.png", alt: "Mahindra" },
  { id: 7, src: "/assets/clients/titan.png", alt: "Titan" },
  { id: 8, src: "/assets/clients/aramco.png", alt: "Aramco" },
  { id: 9, src: "/assets/clients/indian-army.png", alt: "Indian Army" },
  { id: 10, src: "/assets/clients/airtel.png", alt: "Airtel" },
  { id: 11, src: "/assets/clients/Larsenturbo.png", alt: "Larsen & Turbo" },
  { id: 12, src: "/assets/clients/lg.png", alt: "LG" },
  { id: 13, src: "/assets/clients/Autocad.png", alt: "Autocad" },
  { id: 14, src: "/assets/clients/hero.png", alt: "Hero" },
  { id: 15, src: "/assets/clients/kotak.png", alt: "Kotak Mahindra Bank" },
];

const HomeClient = () => {
  const { t } = useContext(LanguageContext);

  const projects = useCountUp(1143, 2500);
  const cities = useCountUp(108, 2500);
  const years = useCountUp(47, 2500);

  return (
    <section className="home-client">
      {/* STATS */}
      <div className="stats-section">
        <div className="stats-overlay">
          <h2 className="stats-title">{t(`HomeClient.completedProjects`)}</h2>

          <div className="stats">
            <div className="stat-card">
              <h3>{projects}+</h3>
              <p>{t(`HomeClient.projects`)}</p>
            </div>

            <div className="stat-card">
              <h3>{cities}+</h3>
              <p>{t(`HomeClient.countries`)}</p>
            </div>

            <div className="stat-card">
              <h3>{years}+</h3>
              <p>{t(`HomeClient.yearsExperience`)}</p>
            </div>
          </div>
        </div>
      </div>

      {/* CLIENTS */}
      <div className="clients-section">
        <h2 className="clients-title">{t(`HomeClient.ourClients`)}</h2>

        <div className="clients-logos">
          <div className="clients-logos-track">
            {clients.map((client) => (
              <div className="client-item" key = {client.id}>
                <img key={client.id} src={client.src} alt={client.alt} />
                <p className="client-name">{client.alt}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeClient;
